import { CreateElement } from "vue";
import i18n from "@/i18n";
import { DataModules } from "@/store/modules/data";
import { DefaultStatusesFilters as TicketStatusesFilters } from "@/data/filters/tickets";
import { DefaultStatusesSorters as TicketStatusesSorters } from "@/data/sorters/tickets";
import { IImportMappingSource } from "@/models/imports";
import { IStatus } from "@/models/statuses";

const firstLabel = (h: CreateElement, status: IStatus) => {
  return h("p", {}, [
    h("strong", {}, status.name),
    ": ",
    h("code", {}, status.code)
  ]);
};

const secondLabel = (h: CreateElement, status: IStatus) => {
  return h("p", { class: "is-size-8" }, [
    h(
      "span",
      { class: "has-text-grey-light" },
      `${i18n.t("_.id_#", { id: status.id })}`
    )
  ]);
};

export const TicketStatusSource: IImportMappingSource = {
  props: {
    availableFilters: TicketStatusesFilters,
    availableSorters: TicketStatusesSorters(),
    usedDataModule: DataModules.STATUSES,
    guardFunctionalities: ["list_statuses"],
    storeParams: querySearch => {
      return querySearch ? { "filter[code|like]": `%${querySearch}%` } : {};
    }
  },
  render: {
    id: (status: IStatus) => status.id,
    firstLabel: (h: CreateElement, status: IStatus) => firstLabel(h, status),
    secondLabel: (h: CreateElement, status: IStatus) => secondLabel(h, status),
    media: null
  }
};
